module.exports = __webpack_public_path__ + "img/home-content-step-index.72ed456f.png";